import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useGetNotificationTasks } from "../../hooks/services/NotificationTask/useOfNotificacionTask";
import { action_setFireLoad, action_setNotificacionTaskList, action_setNotificacionTaskListFiltred, action_setNotificacionTaskMenuItems } from "../../reducers/actions/NotificationTasks/actions";
import { isNullUndefined, isNullUndefinedOrEmpty } from "../../common/Helpers";
import { Card, Col, Row, Table } from "react-bootstrap";
import { ChoiceGroup, CommandBarButton, DirectionalHint, IconButton, OverflowSet, PrimaryButton, SwatchColorPicker, Toggle, TooltipHost } from "@fluentui/react";
import './style.css'
import SidePanelViewBookTask from "./SidePanels/SidePanelViewBookTask";
import SidePanelViewNotification from "./SidePanels/SidePanelViewNotification";
import { __MessageTypes, __NotificationClass, __NotificationTypesMenuTitles, enum__NOTIFICATION_CLASS, enum__NOTIFICATION_INBOX_TYPE, enum__NOTIFICATION_TYPE } from "../../common/Dictionaries";
import moment from "moment";
import { getNotificationsList, setNotificationCompleted, setNotificationImportant, setNotificationPriority, setNotificationViewed } from "../../services/sNotificationAlerts/notificationAlerts.service";
import NotificationTasksCard from "./NotificationTaskCard";
import SidePanelAchieveValidateNotification from "./SidePanels/AchieveValidate/SidePanelAchieveValidateNotification";
import { action_updateAlertCounter } from "../../reducers/actions/SITE/actions";
import DOMPurify from 'dompurify';

const NotificationTasks = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const { 
		_fireLoad: fireLoad,
		_notificationTaskDataList: notificationTaskDataList,
		_notificationTaskDataListFiltred: notificationTaskDataListFiltred,
		_notificationTaskMenuData: notificationTaskMenuData,
	} = useSelector((state) => state.notificationTaskState);

	const {
        _alertCounter: alertCounter,
	} = useSelector((state) => state.notificationAlertState);
					
	const colors = [
		{ id: 0, label: t('data-lang-lbl-priority0'), color: "blue"    },
		{ id: 1, label: t('data-lang-lbl-priority1'), color: "#FF0000" },
		{ id: 2, label: t('data-lang-lbl-priority2'), color: "orange"  },
		{ id: 3, label: t('data-lang-lbl-priority3'), color: "yellow"  },
		{ id: 4, label: t('data-lang-lbl-priority4'), color: "#00FF00" },
	];

	const [currentMenuItem, setCurrentMenuItem] = useState(enum__NOTIFICATION_INBOX_TYPE.UNREAD);
	const [isPanelViewBookOpen, setIsPanelViewBookOpen] = useState(false);
	const [isPanelViewNotificationOpen, setIsPanelViewNotificationOpen] = useState(false);
	const [isPanelAchieveValidateNotificationOpen, setIsPanelAchieveValidateNotificationOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const [orderManager, setOrderManager] = useState({field: null, direction: null});
	const [itemToPanel, setItemToPanel] = useState(null);
	
	useGetNotificationTasks(enum__NOTIFICATION_INBOX_TYPE.INBOX, notificationTaskDataList, fireLoad, notificationTaskMenuData)

	const handlerExecuteAction = (notiticationTask, actionType, task) => {
		switch (notiticationTask.notificationTypeId) {
			case enum__NOTIFICATION_TYPE.ANNOUNCEMENT:
				switch (notiticationTask.notificationClassId) {
					case enum__NOTIFICATION_CLASS.BOOK_MSG_PENDING_RESPONSE_OVERDUE:
						setIsPanelViewBookOpen(false);
						setIsPanelViewNotificationOpen(false);
						if (actionType === "view") {
							setItemToPanel(notiticationTask)
							setIsPanelAchieveValidateNotificationOpen(true)
						}
						else {
							completeRejectTask(actionType, task.id);
						}
						break;
					case enum__NOTIFICATION_CLASS.BOOK_MSG_VISA:
						setItemToPanel(notiticationTask)
						setIsPanelViewBookOpen(true);
						setIsPanelViewNotificationOpen(false);
						setIsPanelAchieveValidateNotificationOpen(false)
						break;
					default:
						break;
				}
				break;
			case enum__NOTIFICATION_TYPE.ANNOUNCEMENT_ROLE:
				setIsPanelViewBookOpen(false);
				setIsPanelViewNotificationOpen(true);
				setIsPanelAchieveValidateNotificationOpen(false)
				break;
			case enum__NOTIFICATION_TYPE.TASK:
				switch (notiticationTask.notificationClassId) {
					case enum__NOTIFICATION_CLASS.BOOK_MSG_VISA_TO_ACHIEVE:
						setIsPanelViewNotificationOpen(false);
						setIsPanelAchieveValidateNotificationOpen(false)
						if (actionType === "view") {
							setItemToPanel(notiticationTask)
							setIsPanelViewBookOpen(true)
						}
						else {
							completeRejectTask(actionType, task.id);
						}
						break;
					default:
						break;
				}
				break;
			case enum__NOTIFICATION_TYPE.TASK_ROLE:
				setIsPanelViewBookOpen(false);
				setIsPanelViewNotificationOpen(false);
				if (actionType === "view") {
					setItemToPanel(notiticationTask)
					setIsPanelAchieveValidateNotificationOpen(true)
				}
				else {
					completeRejectTask(actionType, task.id);
				}
				break;
			default:
				break;
		}
	};

	const fieldActionHandler = async (itemId, actionType, url, _notificationTaskDataList, _notificationTaskDataListFiltred) => {
		const objectNotificationTask = _notificationTaskDataListFiltred.find(x => x.id === itemId);

		await setNotificationViewed(objectNotificationTask.id, true).then(async (response) => {
			if (response.data.succeeded) {

				_notificationTaskDataList.map(item => {
					if (item.id === itemId) {
						item.viewed = true;
					}
				})
				dispatch(action_setNotificacionTaskList(_notificationTaskDataList))

				_notificationTaskDataListFiltred.map(item => {
					if (item.id === itemId) {
						item.viewed = true;
					}
				})
				dispatch(action_setNotificacionTaskListFiltred(_notificationTaskDataListFiltred))
				
				switch (actionType) {
					case 'view':
						handlerExecuteAction(objectNotificationTask, actionType, objectNotificationTask)
						break;
					case 'complete':
					case 'reject':
						handlerExecuteAction(objectNotificationTask, actionType, objectNotificationTask)
						break;
					case 'goto':
						window.open(url)
						break;
					default:
						break;
				}
			}
			else {
				//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
			}

		}).catch(() => {
			//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
		});
	};

	const completeRejectTask = async (actionType, notificationId) => {
		await setNotificationCompleted(notificationId, (actionType === "complete" ? true : false)).then(async (response) => {
			if (response.data.succeeded) {
				
				notificationTaskDataList.map(item => { if (item.id === notificationId) { item.completed = true; } })
				notificationTaskDataListFiltred.map(item => { if (item.id === notificationId) { item.completed = true; } })

				notificationTaskMenuData.map(itemMenu => {
					if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.UNFULFILLED) { itemMenu.item2 = itemMenu.item2 -1; }
					if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.COMPLETED) { itemMenu.item2 = itemMenu.item2 +1; }
				})

				dispatch(action_setNotificacionTaskMenuItems(notificationTaskMenuData));   
				dispatch(action_setNotificacionTaskList(notificationTaskDataList));
				dispatch(action_setNotificacionTaskListFiltred(notificationTaskDataListFiltred));

                //showMessage(inputParam_SetMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
			}
			else {
				//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
			}
		}).catch(() => {
			//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
		});
	};

	const handlerOnClickNotificationTaskRow = async (notificationId, _notificationTaskDataList, _notificationTaskDataListFiltred, _notificationTaskMenuData) => {
		await setNotificationViewed(notificationId, true).then(async (response) => {
			if (response.data.succeeded) {
				manegeViewedObject(notificationId, _notificationTaskDataList, _notificationTaskDataListFiltred, _notificationTaskMenuData);
			}
			else {
				//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
			}
		}).catch(() => {
			//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
		});
	};

	const manegeViewedObject = (notificationId, _notificationTaskDataList, _notificationTaskDataListFiltred, _notificationTaskMenuData) => {
		_notificationTaskDataListFiltred.map(item => {
			if (item.id === notificationId) {
				item.expanded = !item.expanded;
				if (item.viewed === false) {
					item.viewed = true;
					//[##Actualización de controles del menú superior##]
					dispatch(action_updateAlertCounter(alertCounter -1));
					//
					_notificationTaskMenuData.map(itemMenu => { if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.UNREAD) { itemMenu.item2 = itemMenu.item2 -1; } })
					dispatch(action_setNotificacionTaskMenuItems(_notificationTaskMenuData));   
				}
			}
		});

		dispatch(action_setNotificacionTaskList(_notificationTaskDataList));
		dispatch(action_setNotificacionTaskListFiltred(_notificationTaskDataListFiltred));
	};

	const sortByAsc = (list, field) => {
		const sorted = [...list].sort((a, b) => a[field].localeCompare(b[field]));
		return sorted;
	};
	
	const sortByDesc = (list, field) => {
		const sorted = [...list].sort((a, b) => b[field].localeCompare(a[field]));
		return sorted;
	};

	const orderData = (type, upOrder) => {
		switch (type) {
			case 'title':
				dispatch(action_setNotificacionTaskListFiltred(upOrder ? sortByAsc(notificationTaskDataListFiltred, 'title') : sortByDesc(notificationTaskDataListFiltred, 'title')))
				dispatch(action_setNotificacionTaskList(upOrder ? sortByAsc(notificationTaskDataList, 'title') : sortByDesc(notificationTaskDataList, 'title')))
				break;
			case 'expdate':
				dispatch(action_setNotificacionTaskListFiltred(upOrder ? sortByAsc('expirationDate') : sortByDesc('expirationDate')))
				dispatch(action_setNotificacionTaskList(upOrder ? sortByAsc(notificationTaskDataList, 'expirationDate') : sortByDesc(notificationTaskDataList, 'expirationDate')))
				break;
			case 'assigdate':
				dispatch(action_setNotificacionTaskListFiltred(upOrder ? sortByAsc('assignedDate') : sortByDesc('assignedDate')))
				dispatch(action_setNotificacionTaskList(upOrder ? sortByAsc(notificationTaskDataList, 'assignedDate') : sortByDesc(notificationTaskDataList, 'assignedDate')))
				break;
			default:
				break;
		}

		setOrderManager({field: type, direction: upOrder});
	};

	const handlerOnNotificationMenuClick = async (option) => {
		try {
			let serviceResponse = await getNotificationsList(option);
			const response = serviceResponse.data;
			const aux = [];
			
			if (response.succeeded) {
				response.data.forEach(element => { aux.push({...element, expanded: false, editingPriority: false, editingImportant: false}); });
			}

			dispatch(action_setNotificacionTaskListFiltred(aux)); 
		}
		catch (error) {
			dispatch(action_setNotificacionTaskListFiltred([]));                
		}

		setCurrentMenuItem(option)
	};

	const handlerOnImportantChange = async (notificationId, isImportant) => {
		await setNotificationImportant(notificationId, isImportant).then(async (response) => {
			if (response.data.succeeded) {
				notificationTaskDataList.map(item => { if (item.id === notificationId) { item.important = isImportant } });
				notificationTaskDataListFiltred.map(item => { if (item.id === notificationId) { item.important = isImportant } });
				notificationTaskMenuData.map(itemMenu => { if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.IMPORTANT) { itemMenu.item2 = (isImportant ? itemMenu.item2 +1 : itemMenu.item2 -1); } })
				
				dispatch(action_setNotificacionTaskList(notificationTaskDataList));
				dispatch(action_setNotificacionTaskListFiltred(notificationTaskDataListFiltred)); 
				dispatch(action_setNotificacionTaskMenuItems(notificationTaskMenuData));   
			}
			else {
				//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
			}
		}).catch(() => {
			//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
		});
	};

	const handlerOnPriorityColorChange = async (event, id, color, notificationId) => {
		await setNotificationPriority(notificationId, id).then(async (response) => {
			if (response.data.succeeded) {
				notificationTaskDataList.map(item => {
					if (item.id === notificationId) {
						item.priority = id
					}
				});
				dispatch(action_setNotificacionTaskList(notificationTaskDataList));
		
				notificationTaskDataListFiltred.map(item => {
					if (item.id === notificationId) {
						item.priority = id
					}
				});
				dispatch(action_setNotificacionTaskListFiltred(notificationTaskDataListFiltred)); 
			}
			else {
				//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
			}

		}).catch(() => {
			//showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
		});
	};

	const handlerOnEditPriority = (itemId) => {
		const aux_list = [];
		const aux_list_filtred = [];

		notificationTaskDataList.map(item => {
			const aux_item = {...item}
			if (aux_item.id === itemId) {
				aux_item.editingPriority = !aux_item.editingPriority;
			}
			aux_list.push(aux_item);
		});
		dispatch(action_setNotificacionTaskList(aux_list));

		notificationTaskDataListFiltred.map(item => {
			const aux_item = {...item}
			if (aux_item.id === itemId) {
				aux_item.editingPriority = !aux_item.editingPriority;
			}
			aux_list_filtred.push(aux_item);
		});
		dispatch(action_setNotificacionTaskListFiltred(aux_list_filtred));
	};

	const handlerOnEditImportant = (itemId) => {
		const aux_list = []
		const aux_list_filtred = []

		notificationTaskDataList.map(item => {
			const aux_item = {...item}
			if (aux_item.id === itemId) {
				aux_item.editingImportant = !aux_item.editingImportant;
			}
			aux_list.push(aux_item);
		})
		dispatch(action_setNotificacionTaskList(aux_list));

		notificationTaskDataListFiltred.map(item => {
			const aux_item = {...item}
			if (aux_item.id === itemId) {
				aux_item.editingImportant = !aux_item.editingImportant;
			}
			aux_list_filtred.push(aux_item);
		})
		dispatch(action_setNotificacionTaskListFiltred(aux_list_filtred));
	};

	const handlerRefreshGetData = () => {
		dispatch(action_setFireLoad(true));
	};
	
	const initrowdetails = (objItem) => {
		const normalizedNotificationClass = __NotificationClass.find(x => x.key === objItem.notificationClassId);

		return  <Row className="border" style={{margin: "0px", marginTop: "3px"}}>
					<Col xl={12} className="mt-2">
						<Row>
							<Col>
								<Row><Col><b>{ t('data-lang-lbl-notificationclass') }</b></Col></Row>
								<Row><Col> { !isNullUndefined(normalizedNotificationClass) ? t(normalizedNotificationClass.text) : objItem.notificationClass } </Col></Row>
							</Col>
							
								<Col className='col-auto me-auto'>
									<Row>
										<Col>
											<Row><Col style={{whiteSpace: "nowrap"}}><b>{ (objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) ? t('data-lang-lbl-assigneddate') : t('data-lang-lbl-creationdate') }</b></Col></Row>
											<Row><Col>{ !isNullUndefined(objItem.assignedDate) ? moment(objItem.assignedDate).format('DD/MM/YYYY') : t('data-lang-lbl-nodata') }</Col></Row>
										</Col>
										{
											(objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) &&
											<>
												<Col>
													<Row><Col style={{whiteSpace: "nowrap"}}><b>{ t('data-lang-lbl-expirationdate') }</b></Col></Row>
													<Row><Col>{ !isNullUndefined(objItem.expirationDate) ? moment(objItem.expirationDate).format('DD/MM/YYYY') : t('data-lang-lbl-nodata') }</Col></Row>
												</Col>
												<Col>
													<Row><Col style={{whiteSpace: "nowrap"}}><b>{ t('data-lang-lbl-completeddate') }</b></Col></Row>
													<Row><Col>{ !isNullUndefined(objItem.completedDate) ? moment(objItem.completedDate).format('DD/MM/YYYY') : t('data-lang-lbl-nodata') }</Col></Row>
												</Col>
											</>
										}
									</Row>
								</Col>
						</Row>
					</Col>

					<Col xl={12}>
						<Row className="mt-3">
							{
								(objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) &&
								<Col>
									<Row><Col style={{whiteSpace: "nowrap"}}><b>{ t('data-lang-lbl-assignedby') }</b></Col></Row>
									<Row><Col>{ objItem.assignedByUsername }</Col></Row>
								</Col>
							}
							{
								(objItem.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT_ROLE) &&
								<Col></Col>
							}
							<Col className='col-auto me-auto'>
								{
									(objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) &&
									<Row>
										<Col className="my-auto" style={{whiteSpace: "nowrap"}}>{t('data-lang-lbl-changepriority')}</Col>
										<Col className="col-auto me-auto">
											{
												objItem.editingPriority === false &&
												<IconButton iconProps={{iconName: "WindowEdit"}} onClick={() => handlerOnEditPriority(objItem.id)} title={t('data-lang-btn-edit')} />
											}
											{
												objItem.editingPriority === true &&
												<div className="mt-2" style={{ display: "flex", gap: 10 }}>
													{colors.map((item) => (
														<TooltipHost content={ item.label } directionalHint={DirectionalHint.topCenter}>
															<SwatchColorPicker
																columnCount={1}
																cellShape={"circle"}
																colorCells={[{ id: item.id, color: item.color }]}
																cellHeight={15}
																cellWidth={15}
																styles={{focusedContainer: {minWidth: "unset"}}}
																onChange={(event, id, color) => handlerOnPriorityColorChange(event, id, color, objItem.id)}
																selectedId={objItem.priority}
															/>
														</TooltipHost>
													))}
												</div>
											}
										</Col>
									</Row>
								}
								<Row>
									<Col style={{whiteSpace: "nowrap"}}>{t('data-lang-lbl-changeimportant')}</Col>
									<Col className="col-auto me-auto">
										{
											objItem.editingImportant === false &&
											<IconButton iconProps={{iconName: "WindowEdit"}} onClick={() => handlerOnEditImportant(objItem.id)} title={t('data-lang-btn-edit')} />
										}
										{
											objItem.editingImportant === true &&
											<Toggle
												checked={ objItem.important }
												onChange={ () => handlerOnImportantChange(objItem.id, !objItem.important) }
												role="checkbox"
												onText={ t('data-lang-lbl-yes') }
												offText={ t('data-lang-btn-no') }
												styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
											/>
										}
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>

					<Col xl={12} className="mt-2">
						<Row><Col style={{whiteSpace: "nowrap"}}><b>{ t('data-lang-lbl-description') }</b></Col></Row>
						<Row className="border my-1" style={{overflowY: "scroll", height: "150px", minHeight: "150px", marginLeft: "0px", marginRight: "0px"}}>
							<Col className="m-0" style={{overflow: "hidden"}}><div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(objItem.description , { USE_PROFILES: { html: true } }) }}></div></Col>
						</Row>
					</Col>
					<Col xl={12} className="text-end">
						{
							(objItem.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT_ROLE) && !isNullUndefinedOrEmpty(objItem.url) && 
							<PrimaryButton className="my-2" text={t('data-lang-btn-gotopage')} iconProps={{ iconName: 'SkypeCircleArrow' }} onClick={() => fieldActionHandler(objItem.id, 'view', objItem.url, notificationTaskDataList, notificationTaskDataListFiltred)} />
						}
					</Col>
				</Row>
	};

	const handlerOnChangeClassType = (ev, option) => {
		let filtered = []

		switch (option.key) {
			case enum__NOTIFICATION_TYPE.TASK:
				filtered = notificationTaskDataList.filter((item) => (option.key === 0) ? true : ((item.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || item.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE)))
				break;
			case enum__NOTIFICATION_TYPE.ANNOUNCEMENT:
				filtered = notificationTaskDataList.filter((item) => (option.key === 0) ? true : ((item.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT || item.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT_ROLE)))
				break;
			default:
				filtered = notificationTaskDataList;
				break;
		}

		
		dispatch(action_setNotificacionTaskListFiltred(filtered))
	};
	
	const onRenderOverflowButton = (overflowItems) => {
		const buttonStyles = {
			root: {
				minWidth: 0,
				padding: '0 4px',
				alignSelf: 'stretch',
				height: 'auto',
			},
		};
		return (
			<CommandBarButton
				ariaLabel="More items"
				styles={buttonStyles}
				menuIconProps={{ iconName: 'More' }}
				menuProps={{ items: overflowItems }}
			/>
		);
	};

	const onRenderItem = (item) => {
		if (item.onRender) {
		  	return item.onRender(item);
		}
		return <CommandBarButton iconProps={{ iconName: item.icon }} menuProps={item.subMenuProps} text={item.name} styles={item.styles} onClick={item.onClick} />;
	};
  
  	useEffect(() => {
		if (searchTerm.trim() === "") {
			dispatch(action_setNotificacionTaskListFiltred(notificationTaskDataList))
		} else {
			const lowercasedSearchTerm = searchTerm.toLowerCase();
			const filtered = notificationTaskDataList.filter((item) =>
				Object.values(item).some((val) =>
					String(val).toLowerCase().includes(lowercasedSearchTerm)
				) &&
				(currentMenuItem === enum__NOTIFICATION_INBOX_TYPE.IMPORTANT ? item.important === true : true) &&
				(currentMenuItem === enum__NOTIFICATION_INBOX_TYPE.COMPLETED ? item.completed === true : true)
			);
			dispatch(action_setNotificacionTaskListFiltred(filtered))
		}
  	}, [searchTerm, notificationTaskDataList]);

  	return (
		<Card>
			<Card.Body>
			{
				notificationTaskDataListFiltred && notificationTaskDataList &&
				<Row>
					<Col className='col-auto ms-auto'>
					{
						!isNullUndefined(notificationTaskMenuData) && notificationTaskMenuData.map((menuItem) => 
							<Row key={menuItem.item1} className='m-2 border cursor-pointer' style={{color: `${currentMenuItem === menuItem.item1 ? "white" : "" }`, backgroundColor: `${currentMenuItem === menuItem.item1 ? 'gray' : 'white'}`, whiteSpace: "nowrap"}} onClick={() => handlerOnNotificationMenuClick(menuItem.item1)}><Col>{t(__NotificationTypesMenuTitles[menuItem.item1].text)}</Col><Col className='col-auto me-auto'>{`(${menuItem.item2})`}</Col></Row>
						)
					}
					</Col>
					<Col>
						<Row>
							<Col className="mt-2">
								<input
									type="text"
									placeholder={`${t('data-lang-btn-search')}...`}
									value={searchTerm}
									onChange={(e) => setSearchTerm(e.target.value)}
									style={{
										marginBottom: "10px",
										padding: "5px",
										width: "100%",
										borderRadius: "4px",
										border: "1px solid #ccc",
									}}
								/>
							</Col>
							<Col className="col-auto me-auto">
								<ChoiceGroup
									defaultSelectedKey={undefined}
									options={[{ key: 0, text: 'Todo' }, { key: enum__NOTIFICATION_TYPE.TASK, text: t('data-lang-lbl-tasks') }, { key: enum__NOTIFICATION_TYPE.ANNOUNCEMENT, text: t('data-lang-lbl-announcements') }]}
									onChange={handlerOnChangeClassType}
									className="choice-group-horizontal"
									styles={{
										root: {
											display: "flex",
											flexDirection: "row",
											alignItems: "center",
										},
										label: {
											marginRight: "10px",
										},
										flexContainer: {
											display: "flex",
											flexDirection: "row",
											gap: "20px",
										},
									}}
									label="Seleccionar" />
							</Col>
						</Row>
						<div className="table-container">
							<Table className="border">
								<thead  className="border">
									<th className="border" style={{width: "100%"}}>
										<Row>
											<Col>{t('data-lang-lbl-subject')}</Col>
											<Col className="col-auto me-auto my-auto">
												<OverflowSet
													items={[
														{
															key: 'refresh',
															name: t('data-lang-btn-refresh'),
															icon: 'Refresh',
															onClick: handlerRefreshGetData
														},
														{
															key: 'filter',
															name: t('data-lang-lbl-order'),
															icon: 'Sort',
															subMenuProps: {
																items: [
																	{
																		key: 'title',
																		name: t('data-lang-lbl-subject'),
																		icon: 'TextField',
																		styles: { root: { backgroundColor: orderManager.field === "title" ? 'lightgreen' : 'unset' } },
																		subMenuProps: {
																			items: [
																				{ key: 'upsubject', name: 'Ascendente', iconProps: { iconName: 'Ascending' }, onClick: () => orderData('title', true), styles: { root: { backgroundColor: (orderManager.field === "title" && orderManager.direction === true) ? 'lightgreen' : 'unset' } }, },
																				{ key: 'downsubject', name: 'Descendente', iconProps: { iconName: 'Descending'}, onClick: () => orderData('title', false), styles: { root: { backgroundColor: (orderManager.field === "title" && orderManager.direction === false) ? 'lightgreen' : 'unset' } }, },
																			],
																		},
																	},
																	{
																		key: 'expdate',
																		name: t('data-lang-lbl-expirationdate'),
																		icon: 'DateTime',
																		styles: { root: { backgroundColor: orderManager.field === "expdate" ? 'lightgreen' : 'unset' } },
																		subMenuProps: {
																			items: [
																				{ key: 'upexpdate', name: 'Ascendente', iconProps: { iconName: 'Ascending' },onClick: () => orderData('expdate', true), styles: { root: { backgroundColor: (orderManager.field === "expdate" && orderManager.direction === true) ? 'lightgreen' : 'unset' } }, },
																				{ key: 'downexpdate', name: 'Descendente', iconProps: { iconName: 'Descending' },onClick: () => orderData('expdate', false), styles: { root: { backgroundColor: (orderManager.field === "expdate" && orderManager.direction === false) ? 'lightgreen' : 'unset' } }, },
																			],
																		},
																	},
																	{
																		key: 'assigdate',
																		name: t('data-lang-lbl-assigneddate'),
																		icon: 'DateTime',
																		styles: { root: { backgroundColor: orderManager.field === "assigdate" ? 'lightgreen' : 'unset' } },
																		subMenuProps: {
																			items: [
																				{ key: 'upassigdate', name: 'Ascendente', iconProps: { iconName: 'Ascending' }, onClick: () => orderData('assigdate', true), styles: { root: { backgroundColor: (orderManager.field === "assigdate" && orderManager.direction === true) ? 'lightgreen' : 'unset' } }, },
																				{ key: 'downassigdate', name: 'Descendente', iconProps: { iconName: 'Descending' }, onClick: () => orderData('assigdate', false), styles: { root: { backgroundColor: (orderManager.field === "assigdate" && orderManager.direction === false) ? 'lightgreen' : 'unset' } }, },
																			],
																		},
																	},
																],
															},
														},
													]}
													onRenderOverflowButton={onRenderOverflowButton}
													onRenderItem={onRenderItem}
												/>
											</Col>
										</Row>
									</th>
								</thead>
								<tbody  className="table-body border">
									{
										notificationTaskDataListFiltred.map(notificationTask => (
											<tr key={notificationTask.id} style={{backgroundColor: (!notificationTask.viewed ? "#f5f5f5" : "unset")}}>
												<td className="m-0 p-0 py-1">
													<NotificationTasksCard
														inputParam_ObjItem={notificationTask}
														inputParam_HandlerOnClickNotificationTaskRow={handlerOnClickNotificationTaskRow}
														inputParam_FieldActionHandler={fieldActionHandler}
													/>
													{ notificationTask.expanded === true &&  initrowdetails(notificationTask) }
												</td>
											</tr>
										))
									}
								</tbody>
							</Table>
						</div>
					</Col>
				</Row>
			}
			</Card.Body>
			{
				isPanelViewBookOpen &&
				<SidePanelViewBookTask
					inputParam_IsPanelOpen={isPanelViewBookOpen}
					inputParam_SetterIsPanelOpen={setIsPanelViewBookOpen}
					inputParam_NotificationTask={itemToPanel}
					inputParam_ShowNotificationTask={false}
					inputParam_ForceShowComment={itemToPanel.needPanel === false}
					inputParam_ParentEditMode={itemToPanel.notificationClassId === enum__NOTIFICATION_CLASS.BOOK_MSG_VISA_TO_ACHIEVE}
				/>
			}
			{
				isPanelViewNotificationOpen &&
				<SidePanelViewNotification
					inputParam_IsPanelOpen={isPanelViewNotificationOpen}
					inputParam_SetterIsPanelOpen={setIsPanelViewNotificationOpen}
				/>
			}
			{
				isPanelAchieveValidateNotificationOpen && itemToPanel &&
				<SidePanelAchieveValidateNotification
					inputParam_NotificationTask={itemToPanel}
					inputParam_IsPanelOpen={isPanelAchieveValidateNotificationOpen}
					inputParam_SetterIsPanelOpen={setIsPanelAchieveValidateNotificationOpen}
                    inputParam_NeedUpdateNotificationPageList={true}
				/>
			}
		</Card>
  );
};

export default NotificationTasks;